<template>
	<div>
		<div class="header">
			<div class="header-conten">
				<!-- 登录注册list -->
				<ul v-show="isLogin">
					<li v-for="(item,index) in loginList" @click="setLoginOrRegister(index)">{{item}}</li>
				</ul>
				<!-- 登陆成功的下拉弹框 -->
				<div class="dropdowns" v-show="isDrop">
					<el-dropdown trigger="hover">
						<h4><span>欢迎你</span><span v-html="name?name:userName"></span></h4>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item>
								<router-link to="/setinfo" tag="p">个人设置</router-link>
							</el-dropdown-item>
							<el-dropdown-item>
								<router-link to="/ordermanagement" tag="p">订单管理</router-link>
							</el-dropdown-item>
							<el-dropdown-item>
								<router-link to="/setpassword" tag="p">修改密码</router-link>
							</el-dropdown-item>
							<el-dropdown-item>
								<p @click="setExit">退出系统</p>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
				<h2><img src="../assets/02.png" alt="">脑功能检测训练系统</h2>
			</div>
			<!-- 导航 -->
			<div class="router-nav">
				<ul>
					<li>
						<p @click="changeIndex(0)" :class="ind==0?'router-link-exact-active':''">在线检测</p>
					</li>
					<li>
						<p @click="changeIndex(1)" :class="ind==1?'router-link-exact-active':''">我的报告</p>
					</li>
				</ul>
			</div>
		</div>
		<!-- 登录注册修改密码弹框 -->
		<div class="mark" v-show="isMark">
			<div class="mark-content">
				<h3>{{markList.title}}<img src="../assets/03.png" alt="" class="guanbi" @click="shutDown"></h3>
				<div class="myfrom">
					<!-- 登录 -->
					<el-form :model="ruleLogin" :rules="rules" ref="ruleLogin" label-position="top" v-show="isLoginFrorm">
						<el-form-item label="用户名" prop="userTel">
							<el-input type="text" v-model.number="ruleLogin.userTel" auto-complete="off" :maxlength="11" placeholder="请输入手机号"  autocomplete="off" @keyup.enter.native="getOperation('ruleLogin')"></el-input>
						</el-form-item>

						<el-form-item label="密码" prop="userPwd">
							<el-input type="password" v-model="ruleLogin.userPwd" placeholder="请输入密码" auto-complete="off" autocomplete="off" @keyup.enter.native="getOperation('ruleLogin')"></el-input>
						</el-form-item>
						<span class="forgotPassword" @click="setLoginOrRegister(2)">忘记密码</span>
						<el-button class="myfrom-buttons" @click="getOperation('ruleLogin')">登录</el-button>
					</el-form>
					<!-- 登录结束 -->
					<!-- 注册 -->
					<el-form label-position="top" :model="registered" :rules="registeredRules" ref="registered" v-show="isRegForm">
						<el-form-item label="手机号" prop="userTel">
							<el-input type="text" v-model.number="registered.userTel" auto-complete="off" :maxlength="11" placeholder="请输入手机号" @blur="regPhone"></el-input>
						</el-form-item>
						<el-form-item label="密码" prop="zcuserPwd">
							<el-input type="password" v-model="registered.zcuserPwd" placeholder="请输入密码" auto-complete="off" autocomplete="off"></el-input>
						</el-form-item>
						<el-form-item label="验证码" prop="sendSecond" class="reg-text">
							<el-input type="text" v-model="registered.sendSecond" placeholder="请输入验证码" class="regCode" :maxlength="6" auto-complete="off" autocomplete="off" ></el-input>
							<el-button class="but" @click="getRegCode" :disabled="dis">获取验证码<i v-show="isSecond"> {{secondText}}s</i></el-button>
						</el-form-item>
						<el-button class="myfrom-buttons" @click="getOperation('registered')">注册</el-button>
					</el-form>
					<!-- 注册结束 -->
					<!-- 重置密码1 -->
					<el-form label-position="top" v-show="isResetPassword" :model="setNewPassword" :rules="newPas" ref="setNewPassword">
						<el-form-item label="用户名" prop="userTel">
							<el-input type="text" :maxlength="11" v-model.number="setNewPassword.userTel" auto-complete="off" placeholder="手机号" @blur="setregPhone"></el-input>
						</el-form-item>
						<el-form-item label="验证码" prop="sendSecond" class="reg-text">
							<el-input type="text" placeholder="请输入验证码" v-model="setNewPassword.sendSecond" class="regCode" :maxlength="6"></el-input>
							 <el-button class="but" @click="getRegNumber" :disabled="disab">获取验证码<i v-show="isSecondT"> {{secondTextT}}s</i></el-button>
						</el-form-item>
						<el-button class="myfrom-buttons" @click="getOperation('setNewPassword')">下一步</el-button>
					</el-form>
					<!-- 重置密码1结束 -->
					<!-- 重置密码2 -->
					<el-form label-position="top" v-show="isNewPassword" :model="ruleForm2" :rules="rules2" ref="ruleForm2">
						<el-form-item label="请输入新密码" prop="pass">
							<el-input type="password" placeholder="请输入密码" v-model="ruleForm2.pass" auto-complete="off"></el-input>
						</el-form-item>
						<el-form-item label="请确认登录密码" prop="checkPass">
							<el-input type="password" placeholder="请输入密码" v-model="ruleForm2.checkPass" auto-complete="off"></el-input>
						</el-form-item>
						<el-button class="myfrom-buttons" @click="getOperation('ruleForm2')">确定</el-button>
					</el-form>
					<!-- 重置密码2结束 -->
					<span class="myfrom-footer" @click="setLoginOrRegister(1)" v-show="isLoginFrorm">立即注册</span>
					<span class="myfrom-footer" @click="setLoginOrRegister(0)" v-show="isLoginBack">返回登录<img src="../assets/Shape.png" alt=""></span>
				</div>
			</div>
		</div>
		<!-- 点击我的报告 -->
		<div class="nullMark" v-show="isNull">
			<div class="null-content">
				<h3>提示<img src="../assets/03.png" alt="" class="guanbi" @click="shutDown"></h3>
				<div>
					<img src="../assets/duihao.png" alt="">
					<p>登录脑健康检测系统，健康信息立即掌握</p>
					<button @click="goLogin">立即登录</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import store from '../vuex/store';
	import {
		mapGetters
	} from 'vuex';
	const props = {
		name: {
			type: String,
			default: ''
		}
	}
	export default {
		props,
		data() {
			var reg = /^1[3|4|5|7|8][0-9]{9}$/;
			var checkAccount = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('手机号不能为空'));
				}
				setTimeout(() => {
					if (!Number.isInteger(value)) {
						callback(new Error('请输入数字值'));
					} else {
						if (!reg.test(value)) {
							callback(new Error('手机号格式错误'));
						} else {
							callback();
						}
					}
				}, 1000);
			};
			var pwdReg = /^[0-9a-zA-Z_#]{6,16}$/;
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'));
				} else {
					if (this.ruleForm2.checkPass !== '') {
						this.$refs.ruleForm2.validateField('checkPass');
					} else if (!pwdReg.test(value)) {
						callback(new Error('用户名格式错误'));
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm2.pass) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};  
			return {
				isLogin: true, // 登录注册list
				isDrop: false, // 登陆成功的下拉弹框
				isMark: false, // 弹框蒙层
				isLoginFrorm: false,
				isRegForm: false,
				isResetPassword: false,
				isNewPassword: false,
				isLoginBack: false, // 返回登录按钮
				contFlag: 0,
				isNull: false,
				isSecond: false,
				isSecondT: false,
				secondText: 120,
				secondTextT:120,
				userName: "",
				dis: false,
				disab: false,
				phone:'',
				loginList: ["登录", "注册"],
				markList: {
					title: "",
					buttons: "",
					footerImg: ""
				},
				ruleLogin: { // 登录效验
					userTel: '',
					userPwd: ''
				},
				registered: { // 注册效验
					userTel: '',
					
					zcuserPwd: '',
					
					sendSecond: '',
				},
				setNewPassword: { //重置密码
					userTel: '',
					sendSecond: '',
				},
				ruleForm2: { //再次确定
					pass: '',
					checkPass: '',
				},
				rules: {
					userTel: [{
						required: true,
						validator: checkAccount,
						trigger: 'blur'
					}],
					userPwd: [{
						required: true,
						message: '密码不能为空',
						trigger: 'blur'
					}]
				},
				registeredRules: {
					userTel: [{
						required: true,
						validator: checkAccount,
						trigger: 'blur'
					}],
					zcuserPwd: [{
						required: true,
						message: '密码不能为空',
						trigger: 'blur'
					}],
					sendSecond: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}]
				},
				newPas: {
					userTel: [{
						required: true,
						validator: checkAccount,
						trigger: 'blur'
					}],
					sendSecond: [{
						required: true,
						message: '请输入验证码',
						trigger: 'blur'
					}]
				},
				rules2: {
					pass: [{
						required: true,
						validator: validatePass,
						trigger: 'blur'
					}],
					checkPass: [{
						required: true,
						validator: validatePass2,
						trigger: 'blur'
					}],
				},
				navList: [{
					router: '/',
					title: "在线检测"
				}, {
					router: '/mybaogao',
					title: "我的报告"
				}]
			}
		},
		methods: {
			goLogin() {
				this.isNull = false;
				this.isMark = true;
				this.isLoginFrorm = true;
				this.isRegForm = false;
				this.isLoginBack = false;
				this.isResetPassword = false;
				this.isNewPassword = false;
				this.markList.title = "手机号登录";
				this.markList.buttons = "登录";
				this.contFlag = 0;
			},
			setLoginOrRegister(ind) {
				this.setNewPassword.userTel = '';
				this.setNewPassword.sendSecond = '';
				this.registered.userTel = '';
				this.registered.zcuserPwd = '';
				this.registered.sendSecond = '';
				// 点击登录 or 注册
				this.isMark = true;
				this.dis = false;
				this.disab = false;
				if (ind == 0) {
					this.markList.title = "手机号登录";
					this.markList.buttons = "登录";
					this.isRegForm = false;
					this.isLoginFrorm = true;
					this.isLoginBack = false;
					this.isResetPassword = false;
					this.isNewPassword = false;
					this.contFlag = 0;
				} else if (ind == 1) {
					this.markList.title = "手机号注册";
					this.markList.buttons = "注册"
					this.isRegForm = true;
					this.isLoginFrorm = false;
					this.isLoginBack = true;
					this.isResetPassword = false;
					this.isNewPassword = false;
					this.contFlag = 1
				} else if (ind == 2) {
					this.markList.title = "重置密码";
					this.markList.buttons = "下一步";
					this.isResetPassword = true;
					this.isRegForm = false;
					this.isLoginFrorm = false;
					this.isLoginBack = true;
					this.isNewPassword = false;
					this.contFlag = 2
				}
			},
			getOperation(formName) { // 点击弹框下方按钮（登录，注册，下一步）
				if (this.contFlag == 0) { // 点击登录
					this.$refs[formName].validate((valid) => {
						if (valid) {
							this.$http.post(urlLogin.urlLoginTest+'/login.json', {
								phone: this.ruleLogin.userTel,
								password: this.ruleLogin.userPwd,
								role:4
							}).then(function(res) {
								if (res.body) {
									this.ruleLogin.userTel = '';
									this.ruleLogin.userPwd = '';
									localStorage.setItem("token", res.body.token);
									localStorage.setItem("userName", res.body.object.username);
									localStorage.setItem('phone',res.body.object.phone)
									this.userName = localStorage.getItem("userName");
									this.userName.length > 5 ? this.userName = this.userName.substr(0, 5) + "..." : this.userName
									this.isMark = false;
									this.isLogin = false;
									this.isDrop = true;
								} else {
									this.$message({
										message: '错了哦，请确认登录名或密码',
										type: 'error'
									});
								}
							})
						} else {
							return false;
						}
					});
				} else if (this.contFlag == 1) { // 点击注册
					this.$refs[formName].validate((valid) => {
						if (valid) {
							this.$http.post(urls.urltest + "/personal/registUser.json", {
									phone: this.registered.userTel,
									password: this.registered.zcuserPwd,
									code: this.registered.sendSecond
								})
								.then(function(res) {
									if (res.body.status == "100") {
										this.$message({
											message: '验证码超时',
											type: 'error'
										});
									} else {
										console.log(res.body)
										localStorage.setItem("userName", res.body.object.username);
										localStorage.setItem("phone", res.body.object.phone);
										this.userName = localStorage.getItem("userName");
										this.userName.length > 5 ? this.userName = this.userName.substr(0, 5) + "..." : this.userName
										this.isMark = false;
										this.isLogin = false;
										this.isDrop = true;
										this.contFlag = 0;
										localStorage.setItem("token", res.body.token);
										this.isSecond = false;
										this.registered.userTel = '';
										this.ruleLogin.userPwd = '';
										this.setNewPassword.sendSecond = '';
									}
								})

						} else {
							return false;
						}
					})
				} else if (this.contFlag == 2) { // 点击下一步
					this.$refs[formName].validate((valid) => {
						if (valid) {
							this.$http.post(urls.urltest + "/personal/checkPhoneCode.json", {
									code: this.setNewPassword.sendSecond,
									phone: this.setNewPassword.userTel
								})
								.then(function(res) {
									if (res.body) {
										this.markList.buttons = "确定";
										this.isResetPassword = false;
										this.isRegForm = false;
										this.isLoginFrorm = false;
										this.isLoginBack = true;
										this.isNewPassword = true;
										this.contFlag = 3
									} else {
										this.$message({
											message: '验证码输入不正确',
											type: 'error'
										});
										return false;
									}
								})
						} else {
							return false;
						}
					})
				} else if (this.contFlag == 3) { // 点击确定
					this.$refs[formName].validate((valid) => {
						if (valid) {
							this.$http.post(urls.urltest + '/personal/changePassword.json', {
									phone: this.setNewPassword.userTel,
									password: this.ruleForm2.checkPass
								})
								.then(function(res) {
									this.isMark = false;
									this.isLogin = false;
									this.isDrop = true;
									this.contFlag = 0;
									this.$message({
										message: '密码修改成功',
										type: 'success'
									});
									localStorage.setItem("userName", res.body.object.username);
									localStorage.setItem("phone", res.body.object.phone);
									this.userName = localStorage.getItem("userName");
									this.userName.length > 5 ? this.userName = this.userName.substr(0, 5) + "..." : this.userName
									localStorage.setItem("token", res.body.token);
								})
						} else {
							return false;
						}
					})
				}
			},
			regPhone() { // 注册判断用户名是否已注册
				this.$http.post(urls.urltest + '/personal/checkUserExist.json', {
						phone: this.registered.userTel
					})
					.then(function(res) {
						if (res.body == "1") {
							this.$message({
								message: '手机号码已经注册',
								type: 'error'
							});
						}
					})
			},
			setregPhone() { // 重置密码判断用户名
				this.$http.post(urls.urltest + "/personal/checkUserExist.json", {
						phone: this.setNewPassword.userTel
					})
					.then(function(res) {
						if (res.body == "0") {
							this.$message({
								message: '用户不存在',
								type: 'error'
							});
							return false;
						}
					})
			},
			setExit() {
				this.$http.post(urls.urltest + '/personal/loginout.json', {
					token: localStorage.getItem('token')
				}).then(function(res) {
					localStorage.clear();
					// this.userName = localStorage.getItem("userName");
					this.isLogin = true;
					this.isDrop = false;
					this.$router.replace('/')
				})
			},
			shutDown() {
				// console.log(this.ind)
				this.isMark = false;
				this.isNull = false;
				this.dis = false
				this.isSecond = false;
				localStorage.removeItem("token")
			},
			getRegCode() {
				if (this.registered.userTel == '') {
					this.$message({
									message: '请填写手机号码',
									type: 'error'
								});
				} else if(!this.registered.userTel == ''){
					this.$http.post(urls.urltest + '/personal/checkUserExist.json', {
							phone: this.registered.userTel
						})
						.then(function(res) {
							 console.log(+11+res.body)
							if (res.body == "1") {
								this.$message({
									message: '手机号码已经注册',
									type: 'error'
								});
							} else if(res.body == "2"){
								this.$message({
									message: '用户名格式错误',
									type: 'error'
								});
							}else{
								var _this = this;
								this.isSecond = true;
								this.dis = false;
								this.$http.post(urls.urltest + "/personal/getRegistCheckCode.json", {
										phone: this.registered.userTel,
								})
								.then(function(res) {
									// console.log(res.body)
									var timer = null;
									var sT = this.secondText * 1;
									timer = setInterval(function() {
										if (sT > 0) {
											_this.dis = true;
											sT--;
										}
										_this.secondText = sT;
										if (_this.secondText <= 0) {
											_this.dis = false
											clearInterval(timer)
											_this.isSecond = false;
											_this.secondText = 120
										} 
									}, 1000);
								})
							}
						})
				}
			},
			getRegNumber() {
				if (this.setNewPassword.userTel == '') {
					this.$message({
									message: '请填写手机号码',
									type: 'error'
								});
				} else if(!this.setNewPassword.userTel == ''){
					this.$http.post(urls.urltest + '/personal/checkUserExist.json', {
							phone: this.setNewPassword.userTel
						})
						.then(function(res) {
							console.log(res.body)
							if (res.body == "0") {
								this.$message({
									message: '用户不存在',
									type: 'error'
								});
							} else if(res.body == "2"){
								this.$message({
									message: '用户名格式错误',
									type: 'error'
								});
							}else{
								var _this = this;
								this.isSecondT = true;
								this.disab = false;
								this.$http.post(urls.urltest + "/personal/getChangePassWordCode.json", {
									phone: this.setNewPassword.userTel,
								}).then(function(res) {
									// console.log(res.body)
									var timer = null;
									var sT = this.secondTextT * 1;
									timer = setInterval(function() {
										if (sT > 0) {
											_this.disab = true;
											sT--;
										}
										_this.secondTextT = sT;
										if (_this.secondTextT <= 0) {
											clearInterval(timer)
											_this.disab = false;
											_this.isSecondT = false;
											_this.secondTextT = 120
										}
									}, 1000);
								})
							}
						})
				}
			},
			changeIndex(index) {
				if (index == 0) {
					this.$router.replace('/')
					this.$store.dispatch("changeIndex", index)
				} else if (index == 1) {
					if (localStorage.getItem("token")) {
						this.$router.replace('/mybaogao')
						this.$store.dispatch("changeIndex", index)
					} else {
						this.isNull = true;
					}
				}
			}
		},
		created() {
			if (localStorage.getItem("token")) {
				this.isDrop = true;
				this.isLogin = false;
				this.userName = localStorage.getItem("userName");
			    this.userName.length > 5 ? this.userName = this.userName.substr(0, 5) + "..." : this.userName
			}
		},
		store,
		computed: {
			...mapGetters([
				'ind'
			])
		},
	}
</script>


// WEBPACK FOOTER //
// header.vue?f6389110